/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery, gql } from '@apollo/client';
import { ScNavNode } from '@exo/frontend-gql-generated-types/graphql';

const addNesting = (d: number) => {
  if (d == 0) {
    return '';
  }

  return `
    ... on ScNavContentNode {
      ...ContentNode
      ${addNesting(d - 1)}
    }
  `;
};

export const makeQuery = (d: number) => gql`
  query GetMenuItems($baseSiteId: String!, $language: String!, $defaultLanguage: String!) {
    scNavRoot(baseSiteId: $baseSiteId, language: $language, defaultLanguage: $defaultLanguage) {
      ${addNesting(d)}
      ... on ScNavLinkNode {
        id
        title
        link {
          ... on ScNavUrlLink {
            label
            url
            __typename
          }
          ... on ScNavUrlLinkExternal {
            label
            url
            __typename
          }
          __typename
        }
        iconName
        __typename
      }
      ... on ScNavControlNode {
        id
        title
        iconName
        __typename
      }
    }
  }

  fragment ContentNode on ScNavContentNode {
    id
    title
    url {
      id
      label
      __typename
    }
    children {
      id
      title
      link {
        ... on ScNavUrlLink {
          id
          label
          url
          __typename
        }
        ... on ScNavUrlLinkExternal {
          id
          label
          url
          __typename
        }
      }
      __typename
    }
    iconName
    __typename
  }
`;

export const useNavigation = (
  baseSiteId?: string,
  depth = 1,
  language?: string,
  defaultLanguage?: string
) => {
  const { loading, error, data } = useQuery<{ scNavRoot: ScNavNode[] }>(makeQuery(depth), {
    variables: { baseSiteId: baseSiteId, language, defaultLanguage },
    skip: !baseSiteId
  });

  return { loading, error, data };
};
